import { useState } from 'react';

export default function Brands() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const brands = [
    { name: 'SKF', logo: '/brands/skf.jpg' },
    { name: 'FAG', logo: '/brands/fag.png' },
    { name: 'Timken', logo: '/brands/timken.jpg' },
    { name: 'NSK', logo: '/brands/nsk.jpg' },
    { name: 'NTN', logo: '/brands/ntn.jpg' },
    { name: 'Koyo', logo: '/brands/koyo.jpg' }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % Math.ceil(brands.length / 3));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + Math.ceil(brands.length / 3)) % Math.ceil(brands.length / 3));
  };

  return (
    <section id="brands" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Our <span className="text-blue-600">Brands</span>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Partnering with world-leading manufacturers to deliver quality and reliability
          </p>
        </div>

        {/* ITN Flagship Brand Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h4 className="text-3xl font-bold text-blue-900 mb-4">
                ITN - Our Flagship Brand
              </h4>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                ITN represents our commitment to excellence in industrial components. Our flagship brand offers premium quality bearings, chains, and mechanical components designed for the most demanding industrial applications.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="bg-blue-50 px-4 py-2 rounded-lg">
                  <span className="text-blue-800 font-medium">Premium Quality</span>
                </div>
                <div className="bg-blue-50 px-4 py-2 rounded-lg">
                  <span className="text-blue-800 font-medium">Global Standards</span>
                </div>
                <div className="bg-blue-50 px-4 py-2 rounded-lg">
                  <span className="text-blue-800 font-medium">Proven Reliability</span>
                </div>
              </div>
            </div>
            <div className="text-center">
              <div className="bg-white border-2 border-[#224cc4] p-12 rounded-2xl shadow-xl flex items-center justify-center">
                <img 
                  src="/brands/itn.jpg" 
                  alt="ITN - Industrial Technology Network" 
                  className="max-h-32 w-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Brand Carousel */}
        <div className="relative">
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: Math.ceil(brands.length / 3) }).map((_, slideIndex) => (
                <div key={slideIndex} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-3 gap-8">
                    {brands.slice(slideIndex * 3, slideIndex * 3 + 3).map((brand, index) => (
                      <div
                        key={index}
                        className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-shadow duration-300 flex items-center justify-center"
                      >
                        <img
                          src={brand.logo}
                          alt={`${brand.name} Logo`}
                          className="max-h-16 w-auto object-contain"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-3 hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-left-line text-xl text-gray-600"></i>
            </div>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-3 hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xl text-gray-600"></i>
            </div>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-2">
            {Array.from({ length: Math.ceil(brands.length / 3) }).map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                  currentSlide === index ? 'bg-blue-600' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
